module.exports = __webpack_public_path__ + "static/media/affiliates-share.a18bdcea.gif";